<template>
    <product title="Bulk">
        <div slot="description">
            <p>
                P. Pedersen & Søn transporterer korn, halm, flis mm. i Walkingfloor trailer.
            </p>
            <p>
                P. Pedersen & Søn er certificeret til fodertransport.
            </p>
            <p>
                <div class="btn-holder alt">
                    <a href="/static/images/pp_fodertransport_certifikat.pdf"
                        rel="noopener"
                        target="_blank"
                        class="btn-primary text-center text-uppercase active md-round">
                        <i class="fa fa-file-o fa-fw"></i> Se certifikat
                    </a>
                    Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. <!--<a rel="noopener" target="_blank" href="https://www.foedevarestyrelsen.dk/Nyheder/Aktuelt/Sider/Nyheder_2017/Skal_dine_f%C3%B8devarer_skifte_transport%C3%B8r.aspx">her</a>.-->
                </div>
            </p>
            <p>
                <img style="width:calc(50% - 10px);float:left;margin-right:10px;" class="product-image" src="/static/images/bulk_1.jpg" />
                <img style="width:calc(50% - 10px);float:left;margin-left:10px;" class="product-image" src="/static/images/bulk_2.jpg" />
            </p>
        </div>
    </product>
</template>
<script>
    import Product from '../../../components/elements/product'
    export default {
        name: 'Koel',
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// bulk.vue?9ba4a76e